'use client';

import { ReactNode } from 'react';
import { Box, MantineTransition, Transition } from '@mantine/core';
import { useInViewport } from '@mantine/hooks';

export function Animation({
  children,
  transition,
  duration,
  delay,
  inViewport,
}: {
  children: ReactNode;
  transition: MantineTransition;
  duration?: number;
  delay?: number;
  inViewport?: any;
}) {
  const viewPort = useInViewport();

  return (
    <Box
      ref={viewPort.ref}
      pos='relative'
      style={{
        padding: '5px',
        margin: '0',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        maxHeight: '100vh',
        maxWidth: '100vw',
        height: '100%',
      }}
    >
      <Transition
        transition={transition}
        duration={duration}
        mounted={inViewport || viewPort.inViewport}
        enterDelay={delay}
        keepMounted
      >
        {(styles) => <div style={{ ...styles, zIndex: 1 }}>{children}</div>}
      </Transition>
    </Box>
  );
}

export default Animation;
